export enum TERMS_PERMISSIONS {
  TERMS_VIEW = 'TERMS_AND_CONDITIONS_VIEW',
  TERMS_WRITE = 'TERMS_AND_CONDITIONS_WRITE',
}
